export default __webpack_public_path__ + "static/media/logo-dark.30978f94.svg";